/**
 * 过滤对象类型为string
 * 值的前后空格
 * @param obj
 * @returns
 */
export function trimObj(obj) {
  const trimmed = {}
  for (const key in obj) {
    const value = obj[key]
    if (value === null || value === undefined || Array.isArray(value)) {
      trimmed[key] = value
    } else if (typeof value === 'string') {
      trimmed[key] = value.trim()
    } else if (typeof value === 'object') {
      trimmed[key] = trimObj(value)
    } else {
      trimmed[key] = value
    }
  }
  return trimmed
}